import { createFileRoute } from '@tanstack/react-router'

import { preloadListPointOfSaleGroups } from '@/api/react-query'

export const Route = createFileRoute('/_authenticated/settings/points-of-sale/groups')({
	loader: async ({ context }) => await preloadListPointOfSaleGroups(context, {}),
	staticData: {
		crumb: ({ context: { L } }) => L.Settings.PointOfSale.Groups.Title()
	}
})
